<template>
  <div>
    <div v-if="linksStore.isLoading" class="text-center py-8">
      <div class="spinner mx-auto"></div>
      <p class="text-gray-600 mt-2">Loading top links...</p>
    </div>
    
    <div v-else-if="linksStore.topLinks.length === 0" class="text-center py-8">
      <p class="text-gray-600">No links found</p>
    </div>
    
    <div v-else class="space-y-3">
      <div
        v-for="link in linksStore.topLinks"
        :key="link.shortCode"
        class="flex items-center justify-between p-3 border rounded-lg link-card"
      >
        <div class="flex items-center gap-3">
          <div class="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
            <div class="w-2 h-2 bg-white rounded-full"></div>
          </div>
          <span class="shortcode-outline">
            {{ link.shortCode }}
          </span>
          <span class="text-sm font-medium text-gray-900 truncate max-w-xs">
            {{ link.title || link.redirectURL }}
          </span>
          <span v-if="!link.isActive" class="text-xs bg-red-100 text-red-800 px-2 py-1 rounded">
            Inactive
          </span>
          <span v-if="link.expiresAt && link.expiresAt < Date.now()" class="text-xs bg-orange-100 text-orange-800 px-2 py-1 rounded">
            Expired
          </span>
        </div>
        
        <div class="flex items-center gap-4">
          <div class="text-right">
            <p class="text-lg font-semibold text-gray-900">{{ link.clickCount }}</p>
            <p class="text-xs text-gray-600">clicks</p>
          </div>
          <div class="flex gap-2">
            <button
              @click="copyShortUrl(link.shortCode)"
              class="btn btn-secondary btn-sm"
              title="Copy short URL"
            >
              Copy
            </button>
            <router-link
              :to="`/links/${link.shortCode}`"
              class="btn btn-primary btn-sm"
            >
              View
            </router-link>
          </div>
        </div>
      </div>
    </div>
    
    <div v-if="linksStore.topLinks.length > 0" class="mt-4 text-center">
      <router-link
        to="/links"
        class="btn btn-secondary"
      >
        View All Links
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useLinksStore } from '@/stores/links'
import { linksService } from '@/services/links'

const linksStore = useLinksStore()

const copyShortUrl = async (shortCode: string) => {
  try {
    const fullUrl = linksService.getFullShortUrl(shortCode)
    await linksStore.copyToClipboard(fullUrl)
    // You could add a toast notification here
  } catch (error) {
    console.error('Failed to copy URL:', error)
  }
}

onMounted(async () => {
  if (linksStore.topLinks.length === 0) {
    await linksStore.fetchTopLinks(10)
  }
})
</script>
